import common from '@page/common/js/common';
import corpPage from '@global/components/global/staticInfoPage';
import $ from 'jquery';

const Path = require('@global/vendors/path');

corpPage();

// hash listen
function pathStart(n) {
  Path.pathjs.map('#' + n).to(function () {
    $('.about-content').hide();
    $('#corp-content-' + n).fadeIn('slow');
  });
}

for (let i = 0; i < $('#about-list>ul>li').length; i++) {
  pathStart(i);
}
Path.pathjs.root('#0');

Path.pathjs.listen();

/**
 * @description 依據 href 進行Tab class切換
 */

$(document).ready(function () {
  const element = $('.tab-name');
  element.each(function (index, item) {
    const href = $(this).attr('href');
    if (href && window.location.href.includes(href)) {
      $(this).addClass('active');
    }
  });

  element.click(function (event) {
    element.removeClass('active');
    $(this).addClass('active');
  });
});
